<template>
  <div>
    <page-title :title="title"></page-title>
    <p>I'm sorry, but the page you are looking for could not be found.</p>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  export default {
    name: 'page-not-found',
    data () {
      return {
        title: 'Page Not Found'
      }
    },
    components: {
      PageTitle
    }
  }
</script>



// WEBPACK FOOTER //
// PageNotFound.vue?1e9a6508